import React, { lazy } from "react";
import { createRoot } from "react-dom/client";
import { Header } from "./Header";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { AppProps } from "./AppProps";

const App = lazy(() => import('./App'));

const globalClientPortalWindow = (window as any);

export function renderSpa(e: Element, props: AppProps) {
  if (!globalClientPortalWindow.appInsights) {
    globalClientPortalWindow.appInsights = new ApplicationInsights({
      config: {
        connectionString: props.appInsightsConnectionString ? props.appInsightsConnectionString : "InstrumentationKey=e700106a-5dfa-4b9b-8bc4-003836200323;IngestionEndpoint=https://australiasoutheast-0.in.applicationinsights.azure.com/",
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        correlationHeaderExcludedDomains: ['maps.googleapis.com'],
      }
    });
    globalClientPortalWindow.appInsights.loadAppInsights();
    globalClientPortalWindow.appInsights.trackPageView();
  }

  const domNode = createRoot(e);

  if (props.hint == "login") {
    domNode.render(
      <React.StrictMode>
        <Header {...props} />
      </React.StrictMode>
    );
  }
  else {
    domNode.render(
      <React.StrictMode>
        <App {...props} />
      </React.StrictMode>
    );
  }
}

export * from "./webapis"